<template>
  <div class="privacy">
    <navbar />
    <mainContainer />
    <footerBox />
  </div>
</template>

<script>
import navbar from '@/components/navbar.vue'
import footerBox from '@/components/footer.vue'
import mainContainer from './component/mainContainer'
export default {
  name: 'privacy',
  components: {
    navbar,
    footerBox,
    mainContainer
  }
}
</script>

<style lang="scss" scoped>
.privacy {
  background-color: #fff;
}
</style>
